import {
  model,
  Model,
  modelAction,
  prop,
  rootRef,
  findParent,
  detach,
} from "mobx-keystone";
import { computed, observable } from "mobx";
import { Bob } from "./Bob";

@model("exrails/BobNostrConnection")
export class BobNostrConnection extends Model({
  _version: prop(0),
  created_at: prop<string>(),
  uuid: prop<string>(),
  kind: prop<"send_and_receive" | "receive_only">("send_and_receive"),
  name: prop<string>(),
  budget_amount_sats: prop<number | null>(),
  total_amount_left_in_budget: prop<number | null>(),
  budget_renewal_period_days: prop<number | null>(),
  connection_expiration_days: prop<number | null>(),
  budget_last_renewed: prop<string | null>(),
  connection_expiration_measured_from_date: prop<string | null>(),
  nwc_uri: prop<string>(),
}) {
  getRefId() {
    // when `getId` is not specified in the custom reference it will use this as id
    return this.uuid;
  }

  @observable
  editorialViewStatus: "show" | "edit" | "create" | null = null;

  @observable
  isStagedForDeletion = false;

  @modelAction
  setName(name: string) {
    this.name = name;
  }

  @modelAction
  setStagedForDeletion(staged: boolean) {
    this.isStagedForDeletion = staged;
  }
  @modelAction
  setEditorialViewStatus(status) {
    this.editorialViewStatus = status;
    console.log("editorialViewStatus", this.editorialViewStatus);
  }

  @modelAction
  setBudget(
    amount: number | null,
    renewalPeriod: number | null,
    expirationDays: number
  ) {
    this.budget_amount_sats = amount;
    this.budget_renewal_period_days = renewalPeriod;
    this.connection_expiration_days = expirationDays;
  }

  @computed
  get bob() {
    return findParent<Bob>(this, (parentNode) => parentNode instanceof Bob);
  }
}

export const bobNostrConnectionRef = rootRef<BobNostrConnection>(
  "spirit/BobNostrConnectionRef",
  {
    onResolvedValueChange(ref, newThing, oldThing) {
      if (newThing && !oldThing) {
        detach(ref);
      }
    },
  }
);
